// 運営（最小）: 法人の一覧だけ。X-Alfine-Scope: ops で呼ぶ。
import { api } from '../lib/api';
import { formatDateTime } from '../lib/domain';
import { useLoad } from '../lib/useLoad';
import type { Items } from '../lib/types';
import { Card, ErrorText, Loading, Muted, PageTitle } from '../components/ui';

interface Corporation {
  id: string;
  name: string;
  createdAt?: string;
}

export function OpsPage() {
  const { data, error, loading } = useLoad(() => api<Items<Corporation>>('/ops/corporations', { ops: true }).then((r) => r.items), []);
  return (
    <>
      <PageTitle>運営: 法人</PageTitle>
      <ErrorText>{error}</ErrorText>
      {loading ? <Loading /> : null}
      {data && data.length === 0 ? <Muted>法人はまだありません。</Muted> : null}
      {data && data.length > 0 ? (
        <Card className="divide-y divide-line p-0">
          {data.map((c) => (
            <div key={c.id} className="flex flex-wrap items-center gap-2 px-4 py-2.5">
              <span className="font-medium">{c.name}</span>
              <span className="text-xs text-ink-4">{c.id}</span>
              <span className="ml-auto text-xs text-ink-4">{formatDateTime(c.createdAt)}</span>
            </div>
          ))}
        </Card>
      ) : null}
    </>
  );
}
